import React from 'react';
import { Select } from 'antd';
import { TaskStatusGroup, TaskStatusGroupUtils } from '../../../types/TaskStatus';

export const TaskStatusGroupSelect: React.FC<{
  statusGroup: TaskStatusGroup;
  selectStatusGroup: (group: TaskStatusGroup) => void;
}> = ({ statusGroup, selectStatusGroup }) => {
  return (
    <div className="flex flex-col gap-2 mt-5 mb-4">
      <div className="text-neutral-900 text-xs font-semibold leading-none">Status group</div>
      <Select
        onChange={(group) => {
          selectStatusGroup(group);
        }}
        showSearch={false}
        defaultOpen={false}
        autoFocus={true}
        value={statusGroup}
        options={[TaskStatusGroup.notStarted, TaskStatusGroup.inProgress, TaskStatusGroup.completed].map((group) => {
          return {
            label: (
              <div className="text-brand-grey-dark text-sm font-normal leading-tight">
                {TaskStatusGroupUtils.getTitle(group)}
              </div>
            ),
            value: group,
          };
        })}
        size="small"
        className={'w-[164px] '}
        popupMatchSelectWidth={false}
      ></Select>
    </div>
  );
};
